var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users-item--bulk text__center"},[(_vm.status)?_c('span',{staticClass:"text__powder text__bold"},[_vm._v("Batch User")]):_c('span',{staticClass:"text__powder text__bold"},[_vm._v("Non-Batch")])])}
var staticRenderFns = []

export { render, staticRenderFns }